document.addEventListener("DOMContentLoaded", () => {
	const duration = 300;
	const easing = "cubic-bezier(0.4, 0, 0.2, 1)";
	const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

	// ページ内スクロール時にURLを変更しない -----
	const scrollToElement = (target) => {
		const behavior = prefersReducedMotion ? "auto" : "smooth";

		if (behavior === "auto" || Math.abs(target.getBoundingClientRect().top) < 1) {
			target.scrollIntoView({ behavior, block: "start" });
			return Promise.resolve();
		}

		return new Promise((resolve) => {
			let timeoutId;
			const finishScroll = () => {
				window.removeEventListener("scrollend", finishScroll);
				window.clearTimeout(timeoutId);
				resolve();
			};

			window.addEventListener("scrollend", finishScroll, { once: true });
			target.scrollIntoView({ behavior, block: "start" });
			timeoutId = window.setTimeout(finishScroll, 1200);
		});
	};

	const initPageScroll = () => {
		document.querySelectorAll('a[href^="#"]').forEach((link) => {
			const targetSelector = link.getAttribute("href");

			if (!targetSelector) return;

			if (targetSelector === "#") {
				link.addEventListener("click", (event) => event.preventDefault());
				return;
			}

			if (targetSelector === "#terms-btn") return;

			const target = document.querySelector(targetSelector);

			if (!target) return;

			link.addEventListener("click", async (event) => {
				event.preventDefault();
				await scrollToElement(target);
			});
		});
	};

	// 開閉アニメーションの共通処理 -----
	const resetPanelStyles = (panel) => {
		panel.style.removeProperty("height");
		panel.style.removeProperty("opacity");
		panel.style.removeProperty("overflow");
	};

	const openPanel = async (panel) => {
		panel.hidden = false;

		if (prefersReducedMotion) return;

		panel.style.overflow = "hidden";
		const animation = panel.animate(
			[
				{ height: "0", opacity: 0 },
				{ height: `${panel.scrollHeight}px`, opacity: 1 },
			],
			{ duration, easing },
		);

		await animation.finished;
		resetPanelStyles(panel);
	};

	const closePanel = async (panel) => {
		if (!prefersReducedMotion) {
			panel.style.overflow = "hidden";
			const animation = panel.animate(
				[
					{ height: `${panel.getBoundingClientRect().height}px`, opacity: 1 },
					{ height: "0", opacity: 0 },
				],
				{ duration, easing },
			);

			await animation.finished;
		}

		panel.hidden = true;
		resetPanelStyles(panel);
	};

	// .productsの開閉処理 -----
	const initProducts = () => {
		const button = document.querySelector(".products__btn");
		const panel = document.querySelector(".products__detail");
		const buttonText = button?.querySelector(".products__btn-txt");

		if (!button || !panel || !buttonText) return;

		const openText = buttonText.textContent.trim();
		let isAnimating = false;

		const toggleProducts = async () => {
			if (isAnimating) return;

			isAnimating = true;

			try {
				if (button.getAttribute("aria-expanded") === "true") {
					button.classList.remove("is-open");
					button.setAttribute("aria-expanded", "false");
					buttonText.textContent = openText;
					await closePanel(panel);
				} else {
					button.classList.add("is-open");
					button.setAttribute("aria-expanded", "true");
					buttonText.textContent = "閉じる";
					await openPanel(panel);
				}
			} finally {
				isAnimating = false;
			}
		};

		button.addEventListener("click", toggleProducts);
	};

	// .termsの開閉処理 -----
	const initTerms = () => {
		const button = document.querySelector(".terms__btn");
		const panel = document.querySelector(".terms__body");
		const buttonText = button?.querySelector(".terms__btn-txt");

		if (!button || !panel || !buttonText) return;

		const openText = buttonText.textContent.trim();
		let isAnimating = false;

		const toggleTerms = async () => {
			if (isAnimating) return;

			isAnimating = true;

			try {
				if (button.getAttribute("aria-expanded") === "true") {
					button.classList.remove("is-open");
					button.setAttribute("aria-expanded", "false");
					buttonText.textContent = openText;
					await closePanel(panel);
				} else {
					button.classList.add("is-open");
					button.setAttribute("aria-expanded", "true");
					buttonText.textContent = "閉じる";
					await openPanel(panel);
				}
			} finally {
				isAnimating = false;
			}
		};

		button.addEventListener("click", toggleTerms);

		document.querySelectorAll('a[href="#terms-btn"]').forEach((link) => {
			link.addEventListener("click", async (event) => {
				event.preventDefault();
				await scrollToElement(button);

				if (button.getAttribute("aria-expanded") !== "true") {
					await toggleTerms();
				}
			});
		});
	};

	// .faqの開閉処理 -----
	const initFaq = () => {
		document.querySelectorAll(".faq__item").forEach((item, index) => {
			const question = item.querySelector(".faq__question");
			const button = item.querySelector(".faq__question-inner");
			const answer = item.querySelector(".faq__answer");

			if (!question || !button || !answer) return;

			const answerId = answer.id || `faq-answer-${index + 1}`;
			let isAnimating = false;

			answer.id = answerId;
			answer.hidden = true;
			button.setAttribute("aria-controls", answerId);
			button.setAttribute("aria-expanded", "false");

			const toggleAnswer = async () => {
				if (isAnimating) return;

				isAnimating = true;

				try {
					if (button.getAttribute("aria-expanded") === "true") {
						question.classList.remove("is-open");
						button.setAttribute("aria-expanded", "false");
						await closePanel(answer);
					} else {
						question.classList.add("is-open");
						button.setAttribute("aria-expanded", "true");
						await openPanel(answer);
					}
				} finally {
					isAnimating = false;
				}
			};

			button.addEventListener("click", toggleAnswer);
		});
	};

	initPageScroll();
	initProducts();
	initTerms();
	initFaq();
});
